"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm-9 7c0-4.9706 4.0294-9 9-9s9 4.0294 9 9-4.0294 9-9 9-9-4.0294-9-9z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0029 9.7278V7c2.0024 0 3.8566 1.2383 4.6229 3.0872.7663 1.8489.3312 4.0349-1.0847 5.45l-1.9299-1.9288c.6436-.6432.8413-1.6369.493-2.4773-.3483-.8404-1.1911-1.4033-2.1013-1.4033z",
    fill: "#8DE3FF"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0031 7v2.7278c-1.1546 0-2.1503.902-2.2635 2.0504-.1132 1.1484.6873 2.2272 1.8198 2.4523.7337.1459 1.523-.0934 2.052-.6221l1.9299 1.9288c-1.1712 1.1706-2.8899 1.6917-4.5144 1.3687-2.4913-.4953-4.2524-2.8686-4.0035-5.3951C7.2724 8.9843 9.463 7 12.0031 7z",
    fill: "#FFD556"
  })];
};

exports.default = _default;